/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HistoryDto } from '../../models/history-dto';

export interface HistoryControllerFindAllV1$Params {
}

export function historyControllerFindAllV1(http: HttpClient, rootUrl: string, params?: HistoryControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HistoryDto>>> {
  const rb = new RequestBuilder(rootUrl, historyControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HistoryDto>>;
    })
  );
}

historyControllerFindAllV1.PATH = '/api/v1/history';
